<h3>{{title}}</h3>
<app-pdf *ngFor="let cd of companydocuments" [guid]="cd.documentGuid" [name]="cd.name"></app-pdf>
